import { isBlank } from './detailShared'
// The two orders the Workflow tab can list a balanced order's operations in.
//
// NATURAL is the order Sun serves (RN34): the workflow graph read from START to END. This module never
// touches it. BALANCED is the order of the Balanced screen's matrix: line position first, then the
// job's slot inside that position (`jobOrder`, which the Balanced editor writes as 1..n PER COLUMN —
// it is not a route-wide sequence, which is why it cannot order anything on its own).
//
// Pure, like `operationFilter.js`: no `t_`, rows in and rows out.

export const NATURAL_ORDER = 'natural'
export const BALANCED_ORDER = 'balanced'

const BALANCED_TYPES = ['TYPE', 'LINE']

/** Whether the order's workflow carries a balancing at all — approved or not. */
export const isBalancedWorkflow = (balancedType) => BALANCED_TYPES.includes(balancedType)

// Blank sorts last: a job with no position (external, added after the balancing, a balancing left
// halfway) goes behind the last position, in natural order among its peers.
const compareBlankLast = (a, b) => {
  if (isBlank(a) && isBlank(b)) return 0
  if (isBlank(a)) return 1
  if (isBlank(b)) return -1
  return Number(a) - Number(b)
}

/**
 * The rows in the requested order. A NEW array for the balanced order; the input is never mutated.
 *
 * The sort is stable, so whatever position and slot leave tied keeps the natural order it came in.
 *
 * @param {Array} rows operations in natural (process) order
 * @param {string} mode NATURAL_ORDER or BALANCED_ORDER
 * @returns {Array}
 */
export const orderOperations = (rows, mode) => {
  const source = Array.isArray(rows) ? rows : []
  if (mode !== BALANCED_ORDER) return source
  return [...source].sort((a, b) =>
    compareBlankLast(a.linePosition, b.linePosition) || compareBlankLast(a.jobOrder, b.jobOrder))
}
